import type { RunMessage, RunProjectView } from "../api/hooks/useStatefulAgents";

export interface RunProjectOption {
  id: string;
  label: string;
}

/** The projects a scheduled run worked, in the order it worked them. */
export const runProjects = (
  messages: RunMessage[],
  views: RunProjectView[],
  nameFor: (projectId: string) => string,
): RunProjectOption[] => {
  const named = new Map(views.map((v) => [v.project_id, v.project_name]));
  const ids = [...new Set(messages.flatMap((m) => (m.project_id ? [m.project_id] : [])))];
  return ids.map((id) => ({ id, label: named.get(id) || nameFor(id) }));
};

/** A run's transcript with only the chosen projects' briefs and responses. `shown`
 * null shows every project. Messages about no one project stay. */
export const filterRunByProject = (
  messages: RunMessage[],
  views: RunProjectView[],
  shown: ReadonlySet<string> | null,
): { messages: RunMessage[]; views: RunProjectView[] } => {
  if (!shown) return { messages, views };
  return {
    messages: messages.filter((m) => !m.project_id || shown.has(m.project_id)),
    views: views.filter((v) => shown.has(v.project_id)),
  };
};
